import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { ComponentType, SvgIcon } from '@k12/models';
import { ModalType } from '@k12/models';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule, 
    FormsModule,
    MatButtonModule, 
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle, 
    MatInputModule,
    SvgIconComponent
  ],
   
  selector: 'lib-modal-dialog',
  styleUrl: './modal-dialog.component.scss',
  templateUrl: './modal-dialog.component.html'
})
export class ModalDialogComponent {
  @Output() confirmModal = new EventEmitter<string>();
  @Output() cancelModal = new EventEmitter<string>();
  @Output() saveName = new EventEmitter<string>();

  /** Backward-compatible aliases for consumers using componentInstance.onConfirmModal */
  get onConfirmModal(): EventEmitter<string> {
    return this.confirmModal;
  }

  get onCancelModal(): EventEmitter<string> {
    return this.cancelModal;
  }

  get onSaveName(): EventEmitter<string> {
    return this.saveName;
  }

  public ComponentType: typeof ComponentType = ComponentType;
  public dialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<ModalDialogComponent> = inject(MatDialogRef);
  public inputError: WritableSignal<string> = signal('');
  public ModalType: typeof ModalType = ModalType;
  public name: string;
  public showError: WritableSignal<boolean> = signal(false);

  readonly warningIcon = SvgIcon.WarningBlack;

  public errorMessage(message: string) {
    this.inputError.set(message);
    this.showError.set(true);
  }

  public onConfirmDialog(): void {
    this.confirmModal.emit();
  }
  public onCloseDialog(): void {
    this.cancelModal.emit();
    this.dialogRef.close();
  }

  public onResetInput(): void {
    this.showError.set(false);
  }

  public onSaveDialog(): void {
    this.saveName.emit(this.name);
  }

  public onSetInput(value: string) {
    this.name = value;
  }

  public onCancelDialog(): void {
    this.dialogRef.close(false);
  }

  public onContinueDialog(): void {
    this.dialogRef.close(true);
  }
}